/**
 * UrbanInventoryTabbedPanel — Panel izquierdo del módulo urban-inventory
 *
 * @remarks
 * Muestra el inventario de urban_entities con filtros y lista.
 * Es el `leftPanel` registrado en el moduleRegistry.
 * Lee el projectId desde el store de proyecto activo.
 *
 * @module urban-inventory/components
 */

import { useProject } from '../../../projects';
import { useUrbanInventoryStore } from '../store/urban-inventory-store';
import { useUrbanEntities } from '../hooks/useUrbanEntities';
import { UrbanEntityFilters } from './UrbanEntityFilters';
import { UrbanEntityList } from './UrbanEntityList';

export function UrbanInventoryTabbedPanel(): JSX.Element {
  const { projectId } = useProject();

  const { filteredEntities, isLoading, error, detectedEntityTypes, entities } = useUrbanEntities({
    projectId: projectId ?? '',
    autoLoad: !!projectId,
  });

  const layerVisible = useUrbanInventoryStore((s) => s.layerVisible);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '12px 12px 8px',
          borderBottom: '1px solid var(--color-border, #e2e8f0)',
          flexShrink: 0,
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: 600,
            color: 'var(--color-text, #1e293b)',
          }}
        >
          Inventario Urbano
        </h2>

        {/* Resumen */}
        <div
          style={{
            display: 'flex',
            gap: '12px',
            marginTop: '6px',
            fontSize: '11px',
            color: 'var(--color-text-secondary, #64748b)',
          }}
        >
          <span>{entities.length} total</span>
          {filteredEntities.length !== entities.length && (
            <span>{filteredEntities.length} visibles</span>
          )}
          {!layerVisible && <span style={{ color: '#94a3b8' }}>capa oculta</span>}
        </div>
      </div>

      {/* Filtros */}
      <div style={{ flexShrink: 0, borderBottom: '1px solid var(--color-border-subtle, #f1f5f9)' }}>
        <UrbanEntityFilters detectedEntityTypes={detectedEntityTypes} />
      </div>

      {/* Lista */}
      <UrbanEntityList
        entities={filteredEntities}
        isLoading={isLoading}
        error={error}
      />
    </div>
  );
}
